'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import styles from './InlineMap.module.css';
const EXPLORE_MAP_ICON_SRC = '/images/trip-v2/explore-map.png';
interface InlineMapFooterClientProps {
  onExploreMap?: () => void;
}
export function InlineMapFooterClient(t0) {
  const $ = _c(8);
  const {
    onExploreMap
  } = t0;
  const t = useTranslations("journey");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={EXPLORE_MAP_ICON_SRC} alt="" width={20} height={20} aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("overview_explore_map");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className={styles.exploreMapButtonContent}>{t1}{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onExploreMap || $[6] !== t3) {
    t4 = <Button variant="pill" size="fullWidth" onPress={onExploreMap}>{t3}</Button>;
    $[5] = onExploreMap;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}